import { difference } from 'lodash';
import { mixpanel } from '@fiverr-private/obs';
import { FilterLocation } from '../../types';
import store from '../../store';
import { Brief, MIXPANEL_EVENT_PROPERTIES } from '../../../../shared/mixpanel';
import { getFilterAction } from '../../../../shared/utils';
import { FILTER_NAME_MAPPER } from './constants';

type KeyToReport = keyof typeof FILTER_NAME_MAPPER;
type BriefKeys = keyof Brief;

const keyShouldBeReported = (key: BriefKeys): key is KeyToReport =>
    key in FILTER_NAME_MAPPER;

/**
 * The user added or removed a filter
 * @param briefData - briefData before update
 */
export const getFilterAppliedReporter =
    (briefData: Brief) =>
    (
        update: Partial<Brief>,
        filterLocation: FilterLocation,
        viaCarousel = false
    ) => {
        const key = Object.keys(update)[0] as BriefKeys;
        if (!key || !keyShouldBeReported(key)) {
            return;
        }

        const filter = FILTER_NAME_MAPPER[key];
        if (!filter) {
            return;
        }

        const newData = update[key] || [];
        const oldData = briefData[key] || [];

        const [added, removed] = [
            difference(newData, oldData),
            difference(oldData, newData),
        ];

        if (!added.length && !removed.length) {
            return;
        }

        const filterAction = getFilterAction(added, removed);
        const value = [...added, ...removed];

        mixpanel.track('Logo Maker - MPI - Filter Applied', {
            ...store.brief.getData(),
            ...store.user.getData(),
            ...store.listingsType.getData(),
            [MIXPANEL_EVENT_PROPERTIES.FILTER]: filter,
            [MIXPANEL_EVENT_PROPERTIES.FILTER_LOCATION]: filterLocation,
            [MIXPANEL_EVENT_PROPERTIES.FILTER_ACTION]: filterAction,
            [MIXPANEL_EVENT_PROPERTIES.VALUE]: value,
            [MIXPANEL_EVENT_PROPERTIES.VIA_CAROUSEL]: viaCarousel,
        });
    };
